"use client";

/**
 * Sélecteur d'intention du haut de /pricing.
 *
 * Affiché seulement quand on ignore pourquoi la personne est là : visiteur
 * anonyme, ou compte sans objectif d'onboarding. Le choix personnalise le hero,
 * l'ordre des arguments et le parcours affiché, sans rechargement.
 */

import { motion } from "motion/react";
import { useTranslations } from "next-intl";
import SolarIcon from "@/components/ui/SolarIcon/SolarIcon";
import {
    INTENT_ICONS,
    INTENT_LABEL_KEYS,
    PRICING_SELECTABLE_INTENTS,
} from "@/lib/pricingPersonalization";

export default function PricingIntentPicker({ value, onChange }) {
    const t = useTranslations();

    return (
        <motion.div
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.25, ease: "easeOut", delay: 0.1 }}
            className="mt-7"
        >
            <p className="text-xs font-semibold uppercase tracking-wide text-gray-400 dark:text-grayDark-500 mb-3">
                {t("pricing_intent_question")}
            </p>
            <div className="flex flex-wrap items-center justify-center gap-2">
                {PRICING_SELECTABLE_INTENTS.map((intent) => {
                    const isSelected = value === intent;

                    return (
                        <button
                            key={intent}
                            type="button"
                            aria-pressed={isSelected}
                            onClick={() => onChange(intent)}
                            className={`flex items-center gap-2 rounded-full border px-4 py-2 text-sm font-medium transition-colors ${
                                isSelected
                                    ? "border-primary bg-primary/10 text-primary"
                                    : "border-gray-200 bg-white text-gray-600 hover:border-gray-300 hover:text-gray-900 dark:border-grayDark-800 dark:bg-grayDark-900 dark:text-grayDark-300 dark:hover:border-grayDark-700 dark:hover:text-white"
                            }`}
                        >
                            <SolarIcon
                                name={INTENT_ICONS[intent]}
                                className="w-4 h-4 shrink-0"
                            />
                            {t(INTENT_LABEL_KEYS[intent])}
                        </button>
                    );
                })}
            </div>
        </motion.div>
    );
}
